<script>
import { Fragment, cloneVNode, h, isVNode } from 'vue'

export default {
  name: 'AppButtonGroup',
  props: {
    noWrap: Boolean,
    glue: Boolean,
    type: {
      type: String,
      default: 'justify-start',
    },
    classAddon: {
      type: String,
      default: 'mr-3 last:mr-0 mb-3',
    },
    mb: {
      type: String,
      default: '-mb-3',
    },
  },
  methods: {
    decorateChildren(nodes) {
      return nodes.flatMap((node) => {
        if (!node) {
          return []
        }

        if (node.type === Fragment && Array.isArray(node.children)) {
          return this.decorateChildren(node.children)
        }

        if (!isVNode(node)) {
          return [node]
        }

        return [cloneVNode(node, { class: [node.props?.class, this.classAddon] })]
      })
    },
  },
  render() {
    const hasSlot = this.$slots && this.$slots.default
    const mb = this.glue ? null : this.mb
    const noWrap = this.noWrap || this.glue
    const parentClass = [
      'flex',
      'items-center',
      this.type,
      noWrap ? 'flex-nowrap' : 'flex-wrap',
    ]

    if (mb) {
      parentClass.push(mb)
    }

    if (this.glue) {
      parentClass.push('-space-x-px')
    }

    const attrs = {
      ...this.$attrs,
      class: [parentClass, this.$attrs.class],
    }

    const children = hasSlot
      ? this.glue
        ? this.$slots.default()
        : this.decorateChildren(this.$slots.default())
      : null

    return h('div', attrs, children)
  },
}
</script>
